import baseRequest from "../_core/baseRequest";

export default {
    getShiftList: params => baseRequest.post("/shifts/list", params),
    getSnapshotList: params => baseRequest.post("/shifts/snapshot-list", params),
    downloadShiftExcelFile: params => baseRequest.post("/shifts/export", params),
    downloadShiftExcelFileSnapshot: params => baseRequest.post("/shifts/snapshot-export", params),
    deleteShift: params => baseRequest.post(`/shifts/delete`, params),
    updateShift: params => baseRequest.post("/shifts/update", params),
    getShiftScoreList: params => baseRequest.post("/company/shift-report-list", params),
    exportShiftScoreListByCurrentStatus: params =>
        baseRequest.post("/company/export-shift-report-list-by-current-status", params),
    getFutureShiftsList: params => baseRequest.post("/shifts/future-shift-list", params),
    updateShiftCompanyAndSubCompany: params => baseRequest.put("/shifts/update-company", params),
    updateShiftCourier: params => baseRequest.put("/shifts/update-courier", params),
    getShiftScoreObjectionList: params =>
        baseRequest.post("/shifts/reports/objections/list", params),
    createShiftScoreObjection: params => baseRequest.post("/shifts/reports/objections", params),
    getShiftScoreObjection: params =>
        baseRequest.get(`/shifts/reports/objections/${params.objectionId}`),
    createShiftScoreObjectionNote: params =>
        baseRequest.post(`shifts/reports/objections/${params.objectionId}/notes`, params),
    updateShiftScoreObjectionRevision: params =>
        baseRequest.put(`shifts/reports/objections/${params.objectionId}/revision`, params),
    updateShiftScoreObjectionApproval: params =>
        baseRequest.put(`shifts/reports/objections/${params.objectionId}/approval`, params),
    approveShiftReport: params =>
        baseRequest.put(`shifts/reports/${params.reportId}/approve`, params),
    getShiftReportByTcknAndDate: params =>
        baseRequest.post("/shifts/reports/get-by-tckn-and-date", params),
    getShiftReportByCourierIdAndDate: params => baseRequest.post("/shifts/get-by-date", params),
    getShiftCompliance: params => baseRequest.post("/shifts/reports/compliance/list", params),
    getWaitingApproveCount: () => baseRequest.get("/shifts/reports/waiting-approve-count"),

    getDayOffList: params => baseRequest.post("/shifts/day-off/list", params),
    downloadDayOffExcelFile: params => baseRequest.post("/shifts/day-off/export", params),
    updateDayOff: params => baseRequest.post("/shifts/day-off/update", params),
    updateDayOffApproval: params =>
        baseRequest.put(`shifts/day-off/${params.dayOffId}/approval`, params),
    deleteDayOff: params => baseRequest.post(`/shifts/day-off/delete`, params),
    getQuickReactionCourierList: params =>
        baseRequest.post("/shifts/suggestion/quick-reaction-couriers", params),
    postQuickReactionCourierList: params =>
        baseRequest.post("/shifts/suggestion/quick-reaction-to-forecast", params),
    listQuickReactionCourierList: params =>
        baseRequest.post("/shifts/suggestion/list-quick-reaction-couriers", params),
    reportShiftProblem: params => baseRequest.post("/shifts/report-issue", params),
    createShiftReport: params => baseRequest.post("/shifts/reports", params),
    createManuelShift: params => baseRequest.post("/shifts", params)
};
